// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1BELt","content":"RecentSearches_content__2kaS9"};